import angular from 'angular';

angular.module('cloudX').directive('cxFlyin', [
  '$timeout',
  function($timeout) {
    return {
      restrict: 'E',
      scope: {
        item: '=data',
      },
      template: require('./flyIn.html'),
      controller: [
        '$scope',
        '$state',
        'flySvc',
        '$element',
        function($scope, $state, flySvc) {
          $scope.timeout = null;

          if (typeof $scope.item.timeout == 'undefined') {
            $scope.item.timeout = 5000;
          }

          $scope.removeFly = function(fly) {
            flySvc.removeFly(fly);
          };

          $scope.clickAction = function(fly) {
            console.debug("Fly-in action '%s' invoked: %s", fly.actionLabel, fly.action);

            if (typeof fly.action === 'string') {
              $state.go(fly.action, fly.actionParameter);
            } else if (typeof fly.action === 'function') {
              fly.action(fly.actionParameter);
            }

            $scope.hide();
          };

          $scope.hide = function() {
            $scope.visible = false;

            $timeout(function() {
              flySvc.removeFly($scope.item);
            }, 400);
          };

          $scope.pauseHide = function() {
            if ($scope.timeout) {
              $timeout.cancel($scope.timeout);
            }

            $scope.timeout = null;
          };

          $scope.resumeHide = function() {
            if ($scope.item.timeout > 0) {
              $scope.timeout = $timeout($scope.hide, $scope.item.timeout + 400);
            }
          };
        },
      ],
      link: function(scope, element, attrs) {
        $timeout(function() {
          scope.initialized = true;
        }, 0);
        $timeout(function() {
          scope.visible = true;
        }, 400);

        if (scope.item.timeout > 0) {
          scope.timeout = $timeout(scope.hide, scope.item.timeout + 400);
        }
      },
    };
  },
]);
